import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from "axios";
import TitleCard from '../../../components/TitleCard/TitleCard';
import ConfirmModal from '../../../components/ConfirmModal/ConfirmModal';
import GradientButton from '../../../components/GradientButton/GradientButton';
import CancelButton from '../../../components/CancelButton/CancelButton';

const CitiesCreate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const editingCity = location.state?.city || null;

  const [formData, setFormData] = useState({
    department_code: '',
    department_name: '',
    municipal_code: '',
    municipal_name: '',
    type: '',
    longitude: '',
    latitude: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false); // estado para el submit

  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmData, setConfirmData] = useState({
    title: '',
    message: '',
    type: 'info',
  });

  useEffect(() => {
    if (editingCity) {
      setFormData({
        department_code: editingCity.department_code || '',
        department_name: editingCity.department_name || '',
        municipal_code: editingCity.municipal_code || '',
        municipal_name: editingCity.municipal_name || '',
        type: editingCity.type || '',
        longitude: editingCity.longitude || '',
        latitude: editingCity.latitude || '',
      });
    }
  }, [editingCity]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true); // 🔹 deshabilita el botón

  try {
    const token = localStorage.getItem('access_token');

    if (editingCity) {
      await axios.put(
        `${process.env.REACT_APP_API_URL}/city/update/${editingCity._id}`,
        formData,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setConfirmData({
        title: 'Ciudad actualizada',
        message: `La ciudad "${formData.municipal_name}" fue actualizada exitosamente.`,
        type: 'success',
      });
    } else {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/city/create`,
        formData,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setConfirmData({
        title: 'Ciudad creada',
        message: `La ciudad "${formData.municipal_name}" fue creada exitosamente.`,
        type: 'success',
      });
    }

    setShowConfirm(true);
  } catch (err) {
    console.error('Error guardando ciudad:', err);
    setConfirmData({
      title: 'Error',
      message: err.response?.data?.message || 'No se pudo guardar la ciudad. Intenta nuevamente.',
      type: 'error',
    });
    setShowConfirm(true);
  }
};

const handleConfirm = () => {
  setShowConfirm(false);
  setIsSubmitting(false); // 🔹 habilita el botón nuevamente

  if (confirmData.type === 'success') {
    navigate('../masters/cities-list');
  }
};

  return (
    <>
      <TitleCard title={editingCity ? 'Editar Ciudad' : 'Crear Ciudad'} />

      <form onSubmit={handleSubmit} className="bg-white px-6 py-6 mt-4 rounded-lg shadow-md grid grid-cols-1 md:grid-cols-2 gap-6 w-full">
        {/* Código del departamento */}
        <div className="flex flex-col">
          <label htmlFor="department_code" className="text-gray-600 mb-1">Código del departamento</label>
          <input
            type="text"
            name="department_code"
            id="department_code"
            value={formData.department_code}
            onChange={handleChange}
            className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
            required
          />
        </div>

        {/* Nombre del departamento */}
        <div className="flex flex-col">
          <label htmlFor="department_name" className="text-gray-600 mb-1">Nombre del departamento</label>
          <input
            type="text"
            name="department_name"
            id="department_name"
            value={formData.department_name}
            onChange={handleChange}
            className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
            required
          />
        </div>

        {/* Código del municipio */}
        <div className="flex flex-col">
          <label htmlFor="municipal_code" className="text-gray-600 mb-1">Código del municipio</label>
          <input
            type="number"
            name="municipal_code"
            id="municipal_code"
            value={formData.municipal_code}
            onChange={handleChange}
            className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
            required
          />
        </div>

        {/* Nombre del municipio */}
        <div className="flex flex-col">
          <label htmlFor="municipal_name" className="text-gray-600 mb-1">Nombre del municipio</label>
          <input
            type="text"
            name="municipal_name"
            id="municipal_name"
            value={formData.municipal_name}
            onChange={handleChange}
            className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
            required
          />
        </div>

        {/* Latitud */}
        <div className="flex flex-col">
          <label htmlFor="latitude" className="text-gray-600 mb-1">Latitud</label>
          <input
            type="text"
            name="latitude"
            id="latitude"
            value={formData.latitude}
            onChange={handleChange}
            className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
          />
        </div>

        {/* Longitud */}
        <div className="flex flex-col">
          <label htmlFor="longitude" className="text-gray-600 mb-1">Longitud</label>
          <input
            type="text"
            name="longitude"
            id="longitude"
            value={formData.longitude}
            onChange={handleChange}
            className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
          />
        </div>

        {/* Tipo */}
        <div className="flex flex-col">
          <label htmlFor="type" className="text-gray-600 mb-1">Tipo</label>
          <input
            type="text"
            name="type"
            id="type"
            value={formData.type}
            onChange={handleChange}
            className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
          />
        </div>

        {/* Botones - ocupan 2 columnas */}
        <div className="flex self-end gap-2">
          <GradientButton
            type="submit"
            disabled={isSubmitting}
          >
            {isSubmitting
              ? (editingCity ? 'Actualizando...' : 'Creando...')
              : (editingCity ? 'Guardar' : 'Aceptar')}
          </GradientButton>
          <CancelButton onClick={() => navigate(-1)} />
        </div>
      </form>

      <ConfirmModal
        isOpen={showConfirm}
        title={confirmData.title}
        message={confirmData.message}
        type={confirmData.type}
        onConfirm={handleConfirm}
        onClose={() => setShowConfirm(false)}
      />
    </>
  );
};

export default CitiesCreate;
